import { BridgeRoute } from '@lumapps/constants/types';
import { Route } from '@lumapps/router';
import { stripAnyAppPrefixFromUrl } from '@lumapps/router/utils';

import { BKPR_PREFIX, PREFIXES_FOR_SUPPORTED_ROUTES_LIST } from '../constants';

const filterUndefinedValues = <T extends Record<string, any>>(obj: T): Record<string, string> =>
    Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));

/**
 * Maps a LumApps route to a Beekeeper route by stripping the app prefix
 * and adding the Beekeeper prefix if the route is supported.
 */
export const mapToBeekeeperRoute = (route: Route): BridgeRoute => {
    const pathWithoutAppPrefix = stripAnyAppPrefixFromUrl(route.path);
    const isSupportedRoute = PREFIXES_FOR_SUPPORTED_ROUTES_LIST.find((prefix) => pathWithoutAppPrefix.includes(prefix));
    const path = isSupportedRoute ? `${BKPR_PREFIX}${pathWithoutAppPrefix}` : route.path;

    const params = filterUndefinedValues(route.params ?? {});

    const query =
        typeof route.query === 'string'
            ? new URLSearchParams(route.query)
            : new URLSearchParams(filterUndefinedValues(route.query || {}));

    return { path, params, query };
};
